import { render } from "./PortfolioPhotography.vue?vue&type=template&id=39a73b05&scoped=true"
import script from "./PortfolioPhotography.vue?vue&type=script&lang=js"
export * from "./PortfolioPhotography.vue?vue&type=script&lang=js"

import "./PortfolioPhotography.vue?vue&type=style&index=0&id=39a73b05&scoped=true&lang=css"
import "./PortfolioPhotography.vue?vue&type=style&index=1&id=39a73b05&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a73b05"]])

export default __exports__